import { diffWordsWithSpace as diffWordsWithSpaceRaw } from 'diff';

import Colors from '../../styles/Colors';

// biome-ignore lint/suspicious/noExplicitAny: `diff` shim in shims.d.ts is untyped
const diffWordsWithSpace = diffWordsWithSpaceRaw as (a: string, b: string) => Array<any>;

export interface TextDiffProps {
  original: string;
  modified: string;
}

const ADDED: React.CSSProperties = { color: Colors.textDiffGreen };
const REMOVED: React.CSSProperties = {
  textDecoration: 'line-through',
  color: Colors.textDiffRed,
};

export const TextDiff = ({ original, modified }: TextDiffProps) => (
  <>
    {diffWordsWithSpace(original || '', modified || '').map((item, i) => {
      const key = `${item.value}_${i}`;
      if (item.added) {
        return (
          <span key={`added_${key}`} style={ADDED}>
            {item.value}
          </span>
        );
      }
      if (item.removed) {
        return (
          <span key={`removed_${key}`} style={REMOVED}>
            {item.value}
          </span>
        );
      }
      return <span key={`unchanged_${key}`}>{item.value}</span>;
    })}
  </>
);
